export default __webpack_public_path__ + "static/media/FoodWeb_11.82c2ca46.png";